import React from 'react';
import { Avatar, Box, Card, CardContent, makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import { generateInitials } from '../../helpers/generateInitials';
import { CoachNode } from '../../generated/webapp_gql';
import { colors } from '../../themes/colors';

type CoachType = Pick<
  CoachNode,
  'uuid' | 'avatar' | 'firstName' | 'lastName' | 'email' | 'providerType'
>;

const styles = makeStyles({
  card: {
    display: 'flex',
    marginTop: 8,
    borderRadius: 4,
    boxShadow: '0 2px 10px 0 rgba(208, 209, 210, 0.24)',
    border: `solid 2px ${colors.blue7}`,
  },
  image: {
    marginLeft: 10,
  },
  content: {
    padding: '10px !important',
  },
  providerName: {
    fontSize: 14,
    fontWeight: 800,
    color: colors.black3,
  },
  providerType: {
    fontSize: 12,
    fontWeight: 500,
    color: colors.black5,
  },
  emailAddress: {
    fontSize: 12,
    fontWeight: 500,
    color: colors.blue6,
  },
});

interface Props {
  coach: CoachType;
}

const CareTeamCard: React.FC<Props> = ({ coach }) => {
  const classes = styles();

  return (
    <Card className={classes.card}>
      <Box display="flex" flexDirection="row">
        <Box display="flex" alignItems="center" className={classes.image}>
          {coach.avatar && <Avatar src={coach.avatar} />}

          {!coach.avatar && coach.firstName && coach.lastName && (
            <Avatar>{generateInitials([coach.firstName, coach.lastName])}</Avatar>
          )}
        </Box>

        <CardContent className={classes.content}>
          <Typography className={classes.providerName}>
            {coach.firstName} {coach.lastName}
          </Typography>

          <Typography className={classes.providerType}>Coach</Typography>

          <Typography>
            <a href={`mailto:${coach.email}`} className={classes.emailAddress}>
              {coach.email}
            </a>
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
};

export default CareTeamCard;
